import { convertPDFToSlides, confirmPDFToSlides } from "../services/slidesService";
import { LocalStorageService } from './../services/localStorageService';

export const getAccountId = getState => {
    if (getState) {
        return getState().session.defaultAccountId || LocalStorageService.getDefaultAccountId();
    } else {
        return LocalStorageService.getDefaultAccountId();
    }
};

export const SEND_CONVERT_TO_SLIDES_REQUEST = "SEND_CONVERT_TO_SLIDES_REQUEST";
export const SEND_CONVERT_TO_SLIDES_REQUEST_SUCCESS = "SEND_CONVERT_TO_SLIDES_REQUEST_SUCCESS";
export const SEND_CONVERT_TO_SLIDES_REQUEST_FAILURE = "SEND_CONVERT_TO_SLIDES_REQUEST_FAILURE";
export const SEND_CONFIRM_TO_SLIDES_REQUEST = "SEND_CONFIRM_TO_SLIDES_REQUEST";
export const SEND_CONFIRM_TO_SLIDES_REQUEST_SUCCESS = "SEND_CONFIRM_TO_SLIDES_REQUEST_SUCCESS";
export const SEND_CONFIRM_TO_SLIDES_REQUEST_FAILURE = "SEND_CONFIRM_TO_SLIDES_REQUEST_FAILURE";

const sendConvertToSlidesRequest = _ => ({
    type: SEND_CONVERT_TO_SLIDES_REQUEST
});

const sendConvertToSlidesRequestSuccess = _ => ({
    type: SEND_CONVERT_TO_SLIDES_REQUEST_SUCCESS
});

const sendConvertToSlidesRequestFailure = _ => ({
    type: SEND_CONVERT_TO_SLIDES_REQUEST_FAILURE
});

const sendConfirmToSlidesRequest = _ => ({
    type: SEND_CONFIRM_TO_SLIDES_REQUEST
});

const sendConfirmToSlidesRequestSuccess = _ => ({
    type: SEND_CONFIRM_TO_SLIDES_REQUEST_SUCCESS
});

const sendConfirmToSlidesRequestFailure = _ => ({
    type: SEND_CONFIRM_TO_SLIDES_REQUEST_FAILURE
});

export const convertToSlides = (accId, body) => (dispatch, getState) => {
    const defaultAccountId = accId || getAccountId(getState);
     dispatch(sendConvertToSlidesRequest());
    return convertPDFToSlides(defaultAccountId, body).then(data => {
         dispatch(sendConvertToSlidesRequestSuccess());
        return data;
    }).catch(error => {
         dispatch(sendConvertToSlidesRequestFailure());
        return error;
    });
};

export const confirmToSlides = (accId, jobId) => (dispatch, getState) => {
    const defaultAccountId = accId || getAccountId(getState);
     dispatch(sendConfirmToSlidesRequest());
    return confirmPDFToSlides(defaultAccountId, jobId).then(data => {
         dispatch(sendConfirmToSlidesRequestSuccess());
        return data;
    }).catch(error => {
         dispatch(sendConfirmToSlidesRequestFailure());
        return error;
    });
};
